import { List, Row, Skeleton } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { BiSolidTimeFive } from "react-icons/bi";
import { MdDelete, MdOutlineDelete, MdOutlineEdit } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { EventMiddleware } from "../../../Store/Middlewares/EventMiddleware";
import reminderCal from "../../../assets/reminderCal.png";
import {
  CalendarComp,
  DatePickerInput,
  InputField,
  SubmitButton,
  TextComponent,
  TimePickerInput,
} from "../../../components";
import Modal from "../../../components/modal/Modal";
import styles from "./Reminder.module.css";
import dayjs from "dayjs";

const Dropdown = ({ task, setIsEdit, deleteReminder }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  function handleDropdown(e) {
    e.stopPropagation();
    setDropdownOpen((prev) => !prev);
  }

  useEffect(() => {
    document.body.addEventListener("click", () => setDropdownOpen(false));

    return () => {
      document.body.addEventListener("click", () => setDropdownOpen(false));
    };
  }, []);
  return (
    <>
      <TextComponent textClass={styles.dropdownBtn} onClick={handleDropdown}>
        ...
      </TextComponent>
      {dropdownOpen && (
        <Row className={styles.dropdown}>
          <Row className={styles.dropdownItem} onClick={() => setIsEdit(task)}>
            <MdOutlineEdit fontSize="1.1rem" />
            <TextComponent textClass={styles.dropdownText}>Edit</TextComponent>
          </Row>
          <Row
            className={styles.dropdownItem}
            onClick={() => deleteReminder(task.id)}
          >
            <MdOutlineDelete fontSize="1.1rem" />
            <TextComponent textClass={styles.dropdownText}>
              Delete
            </TextComponent>
          </Row>
          {/* <Row
            className={styles.dropdownItem}
            onClick={() =>
              navigate("/events/eventDetail/editTask", {
                state: { headrTitle: "Edit Task" },
              })
            }
          >
            <BiSolidEdit fontSize="1.1rem" />
            <TextComponent textClass={styles.dropdownText}>
              Edit
            </TextComponent>
          </Row> */}
        </Row>
      )}
      {/* <Modal
        isModalOpen={modalOpen}
        setIsModalOpen={setModalOpen}
        closable={true}
        pinkBg={true}
      >
        <Row className={styles.modalContent}>
          <MdDelete className={styles.deleteIcon} />
          <TextComponent textClass={styles.modalText1}>
            Are you sure?
          </TextComponent>
          <TextComponent textClass={styles.modalText2}>
            This reminder will be permanently deleted
          </TextComponent>
          <SubmitButton title="Remove Task" btnClass={styles.modalBtn} />
          <SubmitButton
            title="Cancel"
            outline={true}
            btnClass={styles.modalBtn}
            onClick={() => setModalOpen(false)}
          />
        </Row>
      </Modal> */}
    </>
  );
};

const Reminder = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const ReminderList = useSelector((state) => state.EventReducer.ReminderList);
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const [loading, setloading] = useState(false);
  const [eventDate, seteventDate] = useState("");
  const [time, settime] = useState("");
  const [reminderTitle, setreminderTitle] = useState("");
  const [checklistData, setChecklistData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const dispatch = useDispatch();
  const [markedDate, setMarkedDate] = useState([]);
  // console.log('isModalOpen', isModalOpen);

  const getReminder = (date) => {
    setSelectedDate(date);
    setloading(true);
    let eventData = {
      event_id: EventDetails?.id,
      date: date ? moment(date).format("YYYY-MM-DD") : selectedDate,
    };
    dispatch(EventMiddleware.getReminder(eventData))
      .then((data) => {
        setMarkedDate(data?.dates);
        setloading(false);
      })
      .catch(() => setloading(false));
  };

  useEffect(() => {
    getReminder(selectedDate);
  }, []);

  console.log("EventDetails", EventDetails);

  // const getCalendarData = (date) => {
  //   // let dates = markedDate?.map(function (x) {
  //   //   return moment(x).format("YYYY-MM-DD");
  //   // });
  //   // let selectedDate = moment(date).format("YYYY-MM-DD");
  //   // let exist = dates.includes(selectedDate) ? true : false;

  //   // if (exist) {
  //   //   setloading(true);
  //   //   let eventData = {
  //   //     id: state?.eventData?.id,
  //   //     date: selectedDate,
  //   //     user_role: user,
  //   //   };
  //   //   dispatch(CheckListMiddleware.getCalendarCheckList(eventData))
  //   //     .then((data) => {
  //   //       console.log("data==========================", data);
  //   //       setChecklistData(data?.checklists);
  //   //       setMarkedDate(data?.dates ? data?.dates : []);
  //   //       setSelectedDate(selectedDate);
  //   //       setloading(false);
  //   //     })
  //   //     .catch(() => setloading(false));
  //   // }
  // };
  const dummyData = [
    {
      id: 1,
      name: "Engagement Ceremony",
      date: "21 Mar 2023",
    },
    {
      id: 2,
      name: "Wedding Ceremony",
      date: "21 Mar 2023",
      time: "02:15 PM",
    },
    {
      id: 3,
      name: "Engagement Ceremony",
      date: "20 June 2023 ",
    },
  ];
  function disabledDate(current) {
    let startDate = moment().subtract(1, "days");
    let endDate = moment(EventDetails?.date).add(1, "days");
    
    return current < startDate || current > endDate;
  }
  const onCreateReminder = () => {
    if (!reminderTitle || !eventDate) {
      // setError("All fields are are mandatory.");
      dispatch(
        showAlert({ type: "error", message: "Please enter all the fields" })
      );
      return;
    } else {
      // setopenModal(false);
      let eventData = {
        event_id: EventDetails?.id,
        reminderTitle,
        date: moment(eventDate).format("YYYY-MM-DD"),
        time: time ? moment(time).format("HH:mm") : "",
      };
      // console.log("sadfasfsdfdfghfghfgjkgkjhlyrtuyyti", eventData);
      dispatch(EventMiddleware.createReminder(eventData))
        .then(() => {
          getReminder(selectedDate);
          setIsModalOpen(false);
          setreminderTitle("");
          seteventDate(null);
          settime(null);
        })
        .catch((err) => {
          setIsModalOpen(false);
          // setError(err?.response?.data?.message);
        });
    }
  };

  const onEditReminder = () => {
    if (!isEdit.name || !isEdit.date) {
      // setError("All fields are are mandatory.");
      dispatch(
        showAlert({ type: "error", message: "Please enter all the fields" })
      );
      return;
    } else {
      // setopenModal(false);
      dispatch(
        EventMiddleware.updateReminder({
          ...isEdit,
          date: moment(isEdit.date).format("YYYY-MM-DD"),
          time: isEdit.time && moment(isEdit.time).format("HH:mm"),
        })
      )
        .then(() => {
          getReminder(selectedDate);
          setIsEdit(false);
        })
        .catch((err) => {
          setIsModalOpen(false);
          // setError(err?.response?.data?.message);
        });
    }
  };

  const onDeleteReminder = (id) => {
    dispatch(EventMiddleware.deleteReminder(id));
  };

  const renderItem = (item, index) => {
    return (
      <div className={styles.listItem}>
        <div className={styles.listItemLeft}>
          {/* {item?.name == "Engagement Ceremony" ? ( */}
          <>
            <BiSolidTimeFive className={styles.timeICon} />
            <div className={styles.content}>
              <TextComponent textClass={styles.Name}>
                {item?.name}
              </TextComponent>
              <TextComponent textClass={styles.Date}>
                {item?.date ? moment(item?.date).format("MMMM DD, YYYY") : "--"}
                {item?.time && " | " + moment(item?.time).format("hh:mm A")}
              </TextComponent>
            </div>
          </>
          {/* ) : (
            <>
              <div className={styles.bulb}>
                <SlBulb />
              </div>
              <div className={styles.content}>
                <TextComponent textClass={styles.contentName}>
                  {item?.name}
                </TextComponent>
                <TextComponent textClass={styles.contentDate}>
                  <text>
                    {item?.time
                      ? moment(item?.time).format("MMMM DD, YYYY | hh:mm A")
                      : "--"}
                  </text>
                </TextComponent>
              </div>
            </>
          )} */}
          {/* {item?.name == "Engagement Ceremony" ? (
          <BiSolidTimeFive className={styles.timeICon} />
        ) : (
          <div className={styles.bulb}>
            <SlBulb />
          </div>
        )} */}
        </div>
        <Dropdown
          setIsEdit={setIsEdit}
          task={item}
          deleteReminder={onDeleteReminder}
        />
      </div>
    );
  };

  return (
    <>
      <Row className={styles.rowContRight} onClick={() => setIsModalOpen(true)}>
        <img src={reminderCal} />
        <TextComponent
          textClass={styles.remindertext}
          text={"Create Reminder"}
        />
      </Row>
      <div className={styles.mainCon}>
        <div className={styles.leftCol}>
          {/* <CalendarComp reminderHeader setModalOpen={setIsModalOpen} /> */}
          <CalendarComp
            markedDate={ReminderList?.dates}
            getLoanData={getReminder}
          />
        </div>
        <div className={styles.rightCol}>
          <TextComponent textClass={styles.dateText}>
            {moment(selectedDate).format("DD MMMM")}
          </TextComponent>
          <Skeleton loading={loading}>
            <List
              className={styles.list}
              dataSource={ReminderList?.reminders}
              renderItem={renderItem}
            />
          </Skeleton>
        </div>
      </div>
      {isModalOpen && (
        <Modal
          grayBg
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          className={styles.modal}
          closable
        >
          <TextComponent textClass={styles.modalHeading}>
            Set Reminder
          </TextComponent>
          <div className={styles.inputs}>
            <InputField
              label="Event Name"
              placeholder={"Wedding"}
              value={EventDetails?.name}
              disabled
              // onChange={(e) => setreminderTitle(e.target.value)}
            />
            <InputField
              label="Calendar Entry"
              placeholder={"Wedding"}
              onChange={(e) => setreminderTitle(e.target.value)}
            />
            {/* <DropDown
            placeholder={"SelectTemplate"}
            name={"template"}
            label={"Template"}
            onChange={handleChangeTemplate}
            options={[
              { value: "Indvidual", option: "Indvidual" },
              { value: "Company", option: "Company" },
            ]}
          /> */}
            <DatePickerInput
              placeholder={"02 10 2023"}
              label={"Date"}
              // format={"MM-DD-YYYY"}
              onChange={(d) => {
                seteventDate(d.$d);
              }}
             
              disabledDate={disabledDate}
            />
            <TimePickerInput
              label="Set Time"
              onChange={(t) => {
                settime(t.$d);
              }}
            />
          </div>
          <SubmitButton title="Create Reminder" onClick={onCreateReminder} />
        </Modal>
      )}

      {isEdit && (
        <Modal
          grayBg
          isModalOpen={isEdit}
          setIsModalOpen={setIsEdit}
          className={styles.modal}
          closable
        >
          <TextComponent textClass={styles.modalHeading}>
            Edit Reminder
          </TextComponent>
          <div className={styles.inputs}>
            <InputField
              label="Event Name"
              placeholder={"Wedding"}
              value={EventDetails?.name}
              disabled
              // onChange={(e) => setreminderTitle(e.target.value)}
            />
            <InputField
              label="Calendar Entry/Appointment"
              placeholder={"Wedding"}
              value={isEdit?.name}
              onChange={(e) => setIsEdit({ ...isEdit, name: e.target.value })}
            />
            {/* <DropDown
            placeholder={"SelectTemplate"}
            name={"template"}
            label={"Template"}
            onChange={handleChangeTemplate}
            options={[
              { value: "Indvidual", option: "Indvidual" },
              { value: "Company", option: "Company" },
            ]}
          /> */}
            <DatePickerInput
              placeholder={"02 10 2023"}
              label={"Date"}
              // format={"MM-DD-YYYY"}
              value={dayjs(isEdit?.date)}
              onChange={(d) => {
                setIsEdit({ ...isEdit, date: d.$d });
              }}
              disabledDate={disabledDate}
            />
            <TimePickerInput
              label="Set Time"
              value={isEdit?.time && dayjs(isEdit?.time)}
              onChange={(t) => {
                setIsEdit({ ...isEdit, time: t.$d });
              }}
            />
          </div>
          <SubmitButton title="Update Reminder" onClick={onEditReminder} />
        </Modal>
      )}
    </>
  );
};

export default Reminder;
